import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RotateCw, AlertCircle } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

/**
 * Banner di auto-recovery: appare se il main della pagina mostra ancora skeleton
 * (.animate-pulse o data-stale-loader) dopo 10s. Dà all'utente un modo evidente di
 * ricaricare invece di restare bloccato. Traccia l'evento via PostHog.
 */
export default function StuckLoaderBanner() {
  const [visible, setVisible] = useState(false);
  const [reloading, setReloading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setVisible(false);
    setReloading(false);
    const id = setTimeout(() => {
      const stuck = document.querySelector('main .animate-pulse:not([data-live-pulse]), main [data-stale-loader]');
      if (stuck) {
        // 4b — banner UI è nascosto; teniamo SOLO il tracking PostHog per
        // monitorare la prevalenza del problema in produzione. Se i dati
        // confermano che è raro/sparito, rimuoveremo anche il tracking.
        trackEvent('stuck_loader_detected_silent', {
          path: location.pathname,
          query: location.search,
        });
        // setVisible(true);  // disabled — user feedback: banner troppo invasivo
      }
    }, 10000); // 10s
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  if (!visible) return null;

  const onReload = () => {
    setReloading(true);
    trackEvent('stuck_loader_user_reload');
    window.location.reload();
  };

  return (
    <div
      data-testid="stuck-loader-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] max-w-md w-[calc(100%-2rem)] bg-amber-500/95 dark:bg-amber-600/95 text-amber-50 rounded-xl shadow-2xl p-4 flex items-center gap-3 backdrop-blur-md border border-amber-400/40 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <AlertCircle size={20} className="shrink-0" />
      <div className="flex-1 text-sm">
        <p className="font-semibold leading-tight">Caricamento più lento del solito</p>
        <p className="text-xs opacity-90 mt-0.5">Ricarica per risolvere</p>
      </div>
      <button
        onClick={onReload}
        disabled={reloading}
        data-testid="stuck-loader-reload-btn"
        className="bg-white text-amber-700 hover:bg-amber-50 px-3 py-1.5 rounded-lg text-sm font-semibold flex items-center gap-1.5 transition-colors disabled:opacity-60"
      >
        <RotateCw size={14} className={reloading ? 'animate-spin' : ''} />
        Ricarica
      </button>
    </div>
  );
}
